import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  dashboardContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    padding: 0,
    rowGap: 16,
    '@media (min-width: 1200px)': {
      padding: '16px 24px',
      gap: 24,
    },
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    flexWrap: 'wrap',
    '@media (min-width: 790px)': {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: 24,
    },
  },
  subscriptionDashboardContainer: {
    flexDirection: 'column',
    gap: 24,
  },
  recentOrders: {
    display: 'flex',
    flex: 1,
    padding: '24px',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    '@media (min-width: 790px)': {
      backgroundColor: theme.evPalette.salt[100],
      gap: 16,
    },
  },
  recentOrdersHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: '16px 24px',
    '@media (min-width: 790px)': {
      padding: 0,
      gap: 16,
      flexDirection: 'column',
      '@media (min-width: 1200px)': {
        padding: 0,
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    },
  },
  recentOrdersTitle: {
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '27px',
    color: theme.evPalette.charcoal[900],
    '@media (min-width: 1200px)': {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
  recentOrdersButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    '@media (min-width: 790px)': {
      flexDirection: 'row',
    },
  },
  newOrderBtn: {
    display: 'flex',
    flex: 1,
    height: '100%',
    minHeight: '273px',
    padding: '0px 24px 16px 24px',
    flexDirection: 'column',
    '@media (min-width: 790px)': {
      flexDirection: 'column',
      padding: '16px 0px 0px 0px',
    },
  },
  startNewOrderBtn: {
    width: '100%',
    margin: 'auto',
    '@media (min-width: 790px)': {
      width: 'fit-content',
    },
  },
  legacyRedirectionLinkContainer: {
    display: 'flex',
    minWidth: 'fit-content',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '4px 10px 4px 10px',
  },
  legacyRedirectionLink: {
    fontSize: '12px',
    fontWeight: 500,
    cursor: 'pointer',
  },
}));
